import { Directive } from '@angular/core';

@Directive({
  selector: '[appLanguage]',
})
/**
 * Marker directive used to identify language selection content
 * for projection into designated slots in the application layout.
 *
 * Apply this directive (via the `appLanguage` attribute) to components
 * or elements that should appear in the layout's language selection area.
 */
export class LanguageSlotDirective {}
